import React from 'react';

import { UseCreateTemplateFromReportModalLogic } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.logic';
import { UseCreateTemplateFromReportModalProvider } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/CreateTemplateFromReportModal.provider';
import classes from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/CreateTemplateFromReportForm.module.scss';
import { Description } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/Description/Description';
import { RadioSelection } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/RadioSelection/RadioSelection';
import { TemplateName } from 'components/Dashboards/Reporting/CreateTemplateFromReportModal/components/CreateTemplateFromReportForm/components/TemplateName/TemplateName';
import { ReportTagsSelectWithCreate } from 'components/Dashboards/Reporting/_common/ReportTagsSelectWithCreate/ReportTagsSelectWithCreate';
import { Alert } from 'components/DesignSystem/Alert';

interface Props {
    logic: UseCreateTemplateFromReportModalLogic['logic'];
    api: UseCreateTemplateFromReportModalProvider['api'];
}

export const CreateTemplateFromReportForm = ({ api, logic }: Props) => {
    return (
        <div className={classes.createTemplateFromReportModalContainer}>
            <form className={classes.formSection} onSubmit={logic.form.handleSubmit(logic.handleSubmitForm)}>
                <RadioSelection logic={logic} />
                <TemplateName logic={logic} api={api} />
                <Description logic={logic} />
                {logic.shouldShowTags && (
                    <ReportTagsSelectWithCreate control={logic.form.control} handleChange={logic.handleTagsChange} />
                )}
                <Alert severity={'info'}>
                    Reports that are created using this template will automatically have the selected tags associated
                    with them.
                </Alert>
            </form>
        </div>
    );
};
